var Cookies = require('js-cookie');

export const memberManager = (state = {
  cache: {},
  tagList: {},
  tryingToFetchMembersByTeam: false,
  addMemberForm: {errors: {}, lastSubmit: {}},
  editMemberForm: {errors: {}, lastSubmit: {}},

}, action) => {

  switch(action.type){
    
    case 'REQUEST_MEMBERS_BY_TEAM':

      return {
        ...state,
        tryingToFetchMembersByTeam: true
      }

    case 'RECEIVE_MEMBERS_BY_TEAM_FAIL':

      return {
        ...state,
        tryingToFetchMembersByTeam: false
      }

    case 'RECEIVE_MEMBERS_BY_TEAM_SUCCESS':
      var cache = state.cache;

      cache[action.data.id] = action.data.members;

      let tags = [];
      for(var i in action.data.members){
        for(var ii in action.data.members[i].tags){
          if(!tags.find(t => t == action.data.members[i].tags[ii])){
            tags.push(action.data.members[i].tags[ii]);
          }
        }
      }
      
      let tagList = state.tagList;
      tagList[action.data.id] = tags;

      return {
        ...state,
        tryingToFetchMembersByTeam: false,
        cache: cache,
        tagList: tagList
      }
    
    case 'REQUEST_ADD_MEMBER':

      return {
        ...state,
        tryingToAddMember: true,
        addMemberForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_ADD_MEMBER_FAIL':

      return {
        ...state,
        tryingToAddMember: false,
        failedToAddMember: new Date().getTime(),
        addMemberForm: {...state.addMemberForm, errors: action.data.errors}
      }

    case 'RECEIVE_ADD_MEMBER_SUCCESS':
      var cache = state.cache;

      return {
        ...state,
        tryingToAddMember: false,
        successfullyAddedMember: new Date().getTime(),
        addMemberForm: {errors: {}, lastSubmit: {}}
      }


    case 'REQUEST_RESEND_INVITE':
        
      
      return {
        ...state,
        tryingToResendInvite: true,
        editMemberForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_RESEND_INVITE_FAIL':
      
      return {
        ...state,
        tryingToResendInvite: false,
        failedtoResendInvite: new Date().getTime(),
        editMemberForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_RESEND_INVITE_SUCCESS':

      return {
        ...state,
        tryingToResendInvite: false,
        successfullyResentInvite: new Date().getTime(),
        editMemberForm: {errors: {}, lastSubmit: {}}
      }


    case 'REQUEST_EDIT_MEMBER':
      
      return {
        ...state,
        tryingToEditMember: true,
      }

    case 'RECEIVE_EDIT_MEMBER_FAIL':
      
      return {
        ...state,
        tryingToEditMember: false,
        failedtoEditMember: new Date().getTime()
      }

    case 'RECEIVE_EDIT_MEMBER_SUCCESS':

      var cache = state.cache;
      for(var i in cache[action.data.team_id]){
        if(cache[action.data.team_id][i].id === action.data.id){
          let user_data = cache[action.data.team_id][i].user;
          cache[action.data.team_id][i] = action.data
          cache[action.data.team_id][i].user = user_data;
        }
      }
      
      return {
        ...state,
        cache: cache,
        tryingToEditMember: false,
        successfullyEditedMember: new Date().getTime()
      }


    case 'REQUEST_REMOVE_MEMBER':
      
      return {
        ...state,
        tryingToRemoveMember: true,
      }

    case 'RECEIVE_REMOVE_MEMBER_FAIL':
      
      return {
        ...state,
        tryingToRemoveMember: false,
        failedtoRemoveMember: new Date().getTime()
      }

    case 'RECEIVE_REMOVE_MEMBER_SUCCESS':

      var cache = state.cache;
      cache[action.data.team_id] = cache[action.data.team_id].filter(m => m.id !== action.data.id)

      return {
        ...state,
        cache: cache,
        tryingToRemoveMember: false,
        successfullyRemovedMember: new Date().getTime()
      }


    default:

      return {
        ...state
      }

      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.memberManager.js